<template>
  <b-card no-header no-footer>
    <ValidationObserver ref="form">
      <form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" md="12">
            <template
              v-for="(m, index) in schoolFileAssetModel"
            >
              <div :key="index">
                <form-group-input
                  :ref="index"
                  :type="m.type"
                  :label="typeof m.label === 'string' ? m.label : null"
                  :options="
                    m.type === 'radio'
                      ? getClassicOptions(index)
                      : getOptions(index)
                  "
                  :need-label="true"
                  v-model="m.value"
                  :rules="typeof m.rules !== 'undefined' ? m.rules : null"
                  :disabled="
                    typeof m.disabled !== 'undefined' ? m.disabled : null
                  "
                  :id="index"
                />
              </div>
            </template>
          </b-col>
        </b-row>
        <div>
          <b-button type="submit" variant="primary" class="mt-0"
            ><font-awesome-icon
              icon="spinner"
              spin
              v-if="isLoading"
            ></font-awesome-icon>
            Simpan</b-button
          >
          <b-button
            :to="'/manajer-file-asset'"
            variant="secondary"
            class="ml-3 float-right"
            ><font-awesome-icon
              icon="spinner"
              spin
              v-if="isLoading"
            ></font-awesome-icon>
            Batal</b-button
          >
        </div>
      </form>
    </ValidationObserver>
  </b-card>
</template>

<script>
import {
  saveProcess,
  setModelValue,
  scrollToError,
  objectToOptions,
  classicObjectToOptions,
} from "@/_helpers";
import formGroupInput from "@/components/FormGroupInput.vue";
import SchoolFileAsset from "@/models/SchoolFileAsset.js";

const schoolFileAssetModel = new SchoolFileAsset();

export default {
  components: {
    formGroupInput,
  },
  watch: {
    "$route.params.id": function (val) {
      if (this.mode === "update") {
        this.getDetail();
      }
    },
    totalPromiseAreaCount: async function (val) {
      if (val >= 4) {
        this.initEdit = false;
      }
    },
  },
  computed: {
    mode: function () {
      return this.$route.params.id !== undefined ? "update" : "create";
    },
  },
  data() {
    return {
      totalPromiseAreaCount: 0,
      initEdit: false,
      isLoading: false,
      schoolFileAssetModel: schoolFileAssetModel.init(),
    };
  },
  mounted() {
    if (this.mode === "update") {
      this.getDetail();
    }
  },
  methods: {
    filterModel(search) {
      const filtered = Object.entries(this.schoolFileAssetModel).filter((mdl) => {
        return search.includes(mdl[0]);
      });
      let result = {};
      filtered.forEach((element) => {
        result[element[0]] = element[1];
      });
      return result;
    },
    getOptions(key) {
      return typeof this.schoolFileAssetModel[key].options !== "undefined"
        ? objectToOptions(this.schoolFileAssetModel[key].options)
        : null;
    },
    getClassicOptions(key) {
      return typeof this.schoolFileAssetModel[key].options !== "undefined"
        ? classicObjectToOptions(this.schoolFileAssetModel[key].options)
        : null;
    },
    resetForm() {
      this.$nextTick(() => {
        // clearModelValue(this.schoolFileAssetModel)
        Object.keys(this.schoolFileAssetModel).forEach((key) => {
          this.$refs[key][0].setValue(null);
        });
        this.$refs.form.reset();
      });
    },
    getDetail() {
      this.initEdit = true;
      this.isLoading = true;
      schoolFileAssetModel
        .find(this.$route.params.id, {
          detail: 1,
        })
        .then((resp) => {
          this.isLoading = false;
          Object.keys(this.schoolFileAssetModel).forEach((key) => {
            if (typeof this.$refs[key] !== "undefined") {
              this.$refs[key][0].setValue(resp[key]);
            }
          });
        })
        .catch((error) => {
          if (process.env.NODE_ENV !== "production") {
            console.error(error);
          }
          this.isLoading = false;
        });
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success || this.isLoading) {
          scrollToError(this.$refs.form);
          return false;
        }
        saveProcess(this.schoolFileAssetModel, this.mode === "update")
          .then((model) => {
            this.isLoading = true;
            if (this.mode === "update") {
              schoolFileAssetModel
                .update(this.$route.params.id, model)
                .then(() => {
                  this.isLoading = false;
                  this.$store.dispatch(
                    "notification/success",
                    "Data file berhasil diubah."
                  );
                  this.$router.push("/manajer-file-asset");
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch("notification/error", error);
                });
            } else {
              schoolFileAssetModel
                .create(model)
                .then((resp) => {
                  this.isLoading = false;
                  this.$store.dispatch(
                    "notification/success",
                    "Data file berhasil disimpan."
                  );
                  this.$router.push("/manajer-file-asset");
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch("notification/error", error);
                });
            }
          })
          .catch(() => {});
      });
    },
  },
};
</script>